exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dealer-search-result{-ms-flex-align:end;align-items:flex-end;border:1px solid #aaa;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:10px;padding:10px}.dealer-search-result .dealer-search-details .dealer-name{color:#367c2b;font-size:1.4rem;font-weight:700;padding-bottom:5px}.dealer-search-result .dealer-search-details .dealer-address,.dealer-search-result .dealer-search-details .dealer-email-phone{font-size:1.4rem;padding-bottom:5px}.dealer-search-result .dealer-name{font-size:1.4rem}.cf .dealer-search-result .dealer-search-details .dealer-name,.hitachi .dealer-search-result .dealer-search-details .dealer-name{color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/dealer-search/components/dealer-search-result.scss
// module id = 5102
// module chunks = 0